
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "IETTHCriteria",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/IETTHCriteria.vue